const isResOk = (statusCode: number) => {
    return statusCode >= 200 && statusCode <= 299;
};

export { isResOk };
